import React from "react";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import { CircularProgress, Typography } from "@mui/material";

const Loader = () => {
  const { isLoader } = useSelector((state: any) => state.mmym);
  const { loaderMessage } = useSelector((state: any) => state.confirmation);
  const classes = useStyles();

  // Show loader if either isLoader is true OR loaderMessage is not empty
  const showLoader = isLoader || (!!loaderMessage && loaderMessage.trim() !== "");

  if (!showLoader) return null;

  return (
    <div className={classes.loader}>
      <div className={classes.loaderContent}>
        <CircularProgress />
        {loaderMessage && loaderMessage.trim() !== "" && (
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, marginTop: 1 }}
            className={classes.message}
          >
            {loaderMessage}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Loader;
